<div class="modal-content">
  <div class="modal modal-body">
    <div class="modal__header">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal__title">Oops...</div>

    <img src="assets/images/verify_bug_fixing.svg" width="200" alt="seguranca">
    
    <div class="modal__message"><strong>Você está utilizando um navegador que não permite acesso à câmera do seu dispositivo.</strong></div>

    <div class="modal__message modal__message_highlight"><strong>Por isso, acesse este link apenas no navegador Safari para continuarmos com sua assinatura. Ok?!</strong></div>
    
    <div class="modal__action">
      <app-gradient-button
        label="OK, ENTENDI"
        (click)="onClickConfirm()">
      </app-gradient-button>
    </div>
  </div>
</div>

